import React, { useState, useEffect } from 'react';
import './Snackbar.css'; // Create a CSS file for styling

import snackbarBottom from "./snackbarBottom.png";
import {Check,X} from 'lucide-react';
const Snackbar = ({ message, color,onClose }) => {
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  useEffect(() => {
    // Trigger the animation after a delay (e.g., 500ms)
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 100);
 
    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);
 
  useEffect(() => {
    setVisible(true);

    // Hide snackbar after 3 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const handleClick = () => {
    setVisible(false);
    onClose();
  };

  return ( <div className={`selectThumbImgOuterAll ${visible ? 'show' : ''}`}   style={{zIndex:999999999} }>
   
    <div className={`snackbar ${visible ? 'show' : ''}`} style={{"textAlign":"center",
        // bottom: animate ? '120px' : '0px',
        opacity: animate ? 1 : 0,
         background:"#fff",
        // border:"2px dashed "+color,
        color:"rgba(144, 202, 249,1)",
        transition: 'bottom 1s ease, opacity 1s ease',
      }} onClick={handleClick}>
        <div style={{position:"relative"}}>
<div align="center" style={{padding:"5px",margin:"10px"}}>
{color=="#958FDA"?<X size={70}  color="rgb(227, 56, 88)"/>:color=="rgb(218, 143, 143) "?
<X size={70}  color="rgb(227, 56, 88)"/>:<Check size={70}  color={color}/>}
</div>
<div align="center" style={{marginBottom:"50px"}}>
      {message}

      </div>
      </div>
       <img src={snackbarBottom} alt="" style={{position:'absolute',width:"100%",bottom:"0px",left:"0px",right:"0px",}} />
     
    </div>
 
    </div>
  );
};

export default Snackbar;
